// extracted by mini-css-extract-plugin
export default {"uniform":"uniform_uniform__Otp-I","imageGrid":"uniform_imageGrid__tBC7x"};